import { TLocale } from '@internal/utils/machine/i18n/TLocale'
import { Machine } from '@internal/utils/machine/Machine'
import { ImageRatio } from '@internal/utils/media/ImageRatio'
import { Close } from '@mui/icons-material'
import { IconButton, Typography } from '@renderer-ui-library/mui'
import React, { useCallback, useMemo } from 'react'
import { getMediaUrl } from 'utils/media/getMediaSrc'
import { formatPrice } from 'utils/numbers/formatPrice'
import styles from './compareMachinesItem.module.scss'

type Props = {
  machine: Machine
  locale: TLocale
  onRemoveClick: (machineGroupId: string) => void
}

const width = 69
export const CompareMachinesItem: React.FC<Props> = React.memo(
  ({ machine, locale, onRemoveClick }) => {
    const handleRemoveClick = useCallback(
      () => onRemoveClick(machine.machineGroupId),
      [machine, onRemoveClick]
    )

    const src = useMemo(
      () =>
        machine.previewImage &&
        getMediaUrl(machine.previewImage, {
          width,
          disableMachineWatermark: true,
          ratio: ImageRatio.Landscape,
        }),
      [machine.previewImage]
    )

    return (
      <div className={styles.machineWrapper}>
        <div className={styles.imageWrapper}>
          {src && (
            <img
              src={src}
              loading='lazy'
              alt={machine.name}
              width={width}
              height={width / ImageRatio.Landscape}
            />
          )}
        </div>
        <div className={styles.machineContent}>
          <Typography variant='body2' noWrap>
            {machine.name}
          </Typography>
          <Typography
            variant='caption'
            color='textSecondary'
            component='span'
            noWrap
          >
            {machine.price && formatPrice(locale, machine.price)}
          </Typography>
        </div>
        <div>
          <IconButton onClick={handleRemoveClick}>
            <Close />
          </IconButton>
        </div>
      </div>
    )
  }
)

CompareMachinesItem.displayName = 'CompareMachinesItem'
